import React from "react";
import { Skeleton } from "antd";

function MarketPackageSkeleton({
    count = 5
}) {
    let items = "";
    for (let i = 0; i < count; i++) {
        items += "|";
    }
    return (
        <>
            {
                items.split("").map((i, idx) => (
                    <div
                        // eslint-disable-next-line react/no-array-index-key
                        key={`mp_loading_${idx}`}
                        style={{
                            padding: "12px 18px",
                            border: "1px solid #cbd5e1",
                            borderRadius: "5px",
                            marginBottom: "10px",
                            background: "#ffffff",
                            height: "23mm"
                        }}
                        className="d-flex gap-1"
                    >
                        <div>
                            <Skeleton.Avatar active shape="square" />
                        </div>
                        <div className="d-flex-col gap-5p flex-1">
                            <Skeleton.Button active style={{ height: "5mm", width: "30mm" }} shape="round" />
                            <Skeleton.Button active style={{ height: "3mm", width: "100%" }} shape="round" />
                            <Skeleton.Button active style={{ height: "3mm", width: "60%" }} shape="round" />
                        </div>
                    </div>
                ))
            }
        </>
    );
}

export default MarketPackageSkeleton;
